'use client';

import { startTransition, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { Button } from '@/lib/components/ui/button';
import * as Sentry from '@sentry/nextjs';
import { isStaleServerActionError } from '@/lib/utils/handle-error';
import { cn } from '@/lib/utils/helpers/cn';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();
  const isStaleAction = isStaleServerActionError(error);

  function handleReset() {
    startTransition(() => {
      reset();
      router.refresh();
    });
  }

  function handleReload() {
    window.location.reload();
  }

  useEffect(() => {
    Sentry.captureException(error);
    console.error(error);
  }, [error]);

  return (
    <div
      role="alert"
      className={cn(
        'flex h-full items-center justify-center rounded',
        isStaleAction ? 'bg-blue-50 text-blue-700' : 'bg-red-100 text-red-600'
      )}
    >
      <div className="rounded text-center">
        <h1 className="m-auto my-4 text-3xl">
          {isStaleAction
            ? 'The application has been updated. Please refresh the page to continue.'
            : 'Something went wrong'}
        </h1>
        <div className="flex items-center justify-center gap-10">
          <Button
            className="mt-4 p-2"
            onClick={isStaleAction ? handleReload : handleReset}
          >
            Reload{' '}
          </Button>
        </div>
      </div>
    </div>
  );
}
